import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { ButtonLogin } from './button/ButtonLogin';
import { DivMinWidth } from '../App';
import { LogoBC } from './LogoBC';

type MenuItem = {
  label: string;
  to: string;
  end?: boolean;
};

const defaultItems: MenuItem[] = [
  { label: 'Home', to: '/', end: true },
  { label: 'Awards', to: '/awards' },
  { label: 'Membership', to: '/membership' },
  { label: 'GIS', to: '/gis' },
];

const MenuPill = styled.div`
  width: 100%;
  margin-left: auto;

  position: relative;
  padding: 16px 26px;
  z-index: 1;

  > * {
    position: relative;
    z-index: 2;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: #ffffff;
    border-radius: 20px;
    transform: skewX(18deg);
    border: 2px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 18px 45px rgba(0, 0, 0, 0.10),
    0 3px 10px rgba(0, 0, 0, 0.05);
    z-index: 1;
  }
`;

// const Nav = styled.nav`
//   display: flex;
//   justify-content: center;
// `;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  display: flex;
  align-items: center;
  gap: 26px;
`;

const Item = styled.li`
  display: flex;
  align-items: center;
`;

const Link = styled(NavLink)<{ $activeColor: string; $textColor: string }>`
  text-decoration: none;
  font-size: 20px;
  font-weight: 700;
  font-family: "futura-pt", sans-serif;
  letter-spacing: 0.2px;
  color: ${({ $textColor }) => $textColor};
  transition: color 160ms ease, transform 160ms ease;

  &:hover {
    transform: translateY(-1px);
  }

  &.active {
    color: ${({ $activeColor }) => $activeColor};
  }
`;

const MenuGridStyled = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  column-gap: 50px;
  width: 100%;
`;

const NavStyled = styled.nav`
  display: flex;
  justify-content: center;
`;

export const MainMenuNav: React.FC = () => {
  const menu = useMemo(() => defaultItems, [defaultItems]);

  return (<DivMinWidth>
            <MenuPill>
                    <MenuGridStyled>
                    <LogoBC size={'80px'}/>
                        <NavStyled aria-label="Navigation">
                            <List>
                                {menu.map((item) => (
                                    <Item key={item.to}>
                                        <Link
                                            to={item.to}
                                            end={item.end}
                                            $textColor={'black'}
                                            $activeColor={'red'}
                                        >
                                            {item.label}
                                        </Link>
                                    </Item>
                                ))}
                            </List>
                        </NavStyled>
                        <ButtonLogin/>
                    </MenuGridStyled>
            </MenuPill>
        </DivMinWidth>

  );
};
